<div *ngIf="translationContentLoaded">
  <router-outlet></router-outlet>
</div>
<app-session-popup
  *ngIf="sessionService.sessionWarningModelOpen"
  [showPopup]="sessionService.sessionWarningModelOpen"
  (emitPopupStatus)="sessionService.extendSession()"
></app-session-popup>
<app-loading-modal></app-loading-modal>
